{
    "World": {
        "center": [
            4.999999987376214e-7,
            11.824804687500027
        ],
        "zoom": 1.3,
        "radius": 4.5,
        "country_opacity": 0.5,
        "marker_symbol": "circle"
    },
    "Europe": {
        "center": [
            8.451439106121498,
            53.22866653708705
        ],
        "zoom": 3.6,
        "radius": 3.5,
        "country_opacity": 0.5,
        "marker_symbol": "circle"
    },
    "DOMOS": {
        "center": [
            -55.70894827818417,
            -11.190097150084284
        ],
        "zoom": 2,
        "radius": 2.5,
        "country_opacity": 0.5,
        "marker_symbol": "circle"
    },
    "xEMEP": {
        "center": [
            8.451439106121498,
            53.22866653708705
        ],
        "zoom": 3.6,
        "radius": 2.5,
        "country_opacity": 0.5,
        "marker_symbol": "square"
    }
}